<template>
  <div class="wrap talk re-style">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <template v-if="isArrived">
          <article  class="certification">
            <section class="txt return">
              <p class="return-txt">
                <span class="return-txt-span">키트 배송을 기다려 주세요</span>
                <br />
                곧 키트를 배송해 드릴게요
                <br />
                배송된 키트에 중고폰을 포장 하고
                <br />
                준비됐어요 버튼을 눌러주세요
              </p>
            </section>
          </article>
          <div id="regBtnDiv" class="ui-buttons">
            <ul class="ui-buttons__list">
              <li class="ui-buttons__item">
                <button
                  type="button"
                  class="ui-button ui-basic-button"
                  @click="handleCloseBtn()"
                >
                  확인
                </button>
              </li>
            </ul>
          </div>
          <div class="cs-center row row_ac row_jsc">
            <span class="qa">고객센터 문의 </span>
            <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
          </div>

        </template>
        <template v-if="!isArrived">
          <template v-if="isCheckedOrder">
            <section class="form-section">
              <h2 class="page-header__title">
                픽업 신청 완료
              </h2>
            </section>
            <article  class="certification">
              <section class="txt return">
                <p class="return-txt">
                  <span class="return-txt-span">이미 픽업 신청이 완료되었어요</span>
                  <br />
                  곧 기사님이 배송 키트를 픽업해요
                  <br />
                  검수센터에 도착하면,
                  <br />
                  하루 이내에 판매 금액을 알림톡으로 안내드릴게요
                </p>
              </section>
            </article>
            <div id="regBtnDiv" class="ui-buttons">
              <ul class="ui-buttons__list">
                <li class="ui-buttons__item">
                  <button
                    type="button"
                    class="ui-button ui-basic-button"
                    @click="handleCloseBtn()"
                  >
                    확인
                  </button>
                </li>
              </ul>
            </div>
            <div class="cs-center row row_ac row_jsc">
              <span class="qa">고객센터 문의 </span>
              <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
            </div>

          </template>
          <template v-else>
            <template v-if="!isDone">
              <section class="form-section mar_b0">
                <p class="page-header__big-text mar_b0">
                  중고폰을 보내기 전에,<br> 아래 내용을 확인하고 동의해 주세요
                </p>
              </section>
              <section class="form-section">
                <div class="agree-box">
                  <h4 class="title2">도난/분실 제품 처리 동의</h4>
                  <ol class="list">
                    <li class="list__item">
                      <p>
                        민팃 Home으로 판매한 제품이 <b>도난/분실 등록된 제품</b>일 경우 판매가 취소되고 법적 조치를 취합니다.
                      </p>
                    </li>
                  </ol>
                  </div>
                  <div class="agree-box">
                  <h4 class="title2">잠금 해제/계정 삭제 협조 동의</h4>
                  <ol class="list">
                    <li class="list__item">
                      <p>
                        중고폰의 <b>잠금 해제</b>와 안드로이드 폰인 경우 구글/삼성 <b>계정 삭제</b>, 아이폰인 경우 iCloud <b>계정의 로그아웃</b>을 진행해야 합니다.
                      </p>
                    </li>
                  </ol>
                  </div>
                  <div class="agree-box">
                  <h4 class="title2">데이터 완전삭제 동의</h4>
                  <ol class="list">
                    <li class="list__item">
                      <p>
                        민팃 Home을 신청한 제품의 모든 데이터는 완전삭제 솔루션을 통해 삭제되어 복원이 불가능하며 이에 동의합니다.
                      </p>
                    </li>
                  </ol>
                </div>
                <div class="check-wrap row agrm-form-input-area">
                  <DxCheckBox
                    text="전체 이용약관 동의"
                    v-model="isChecked"
                  />
                  <span class="cstm-font-red">(필수)</span>
                </div>
              </section>
              <div id="regBtnDiv" class="ui-buttons">
                <ul class="ui-buttons__list">
                  <li class="ui-buttons__item">
                    <button
                      type="button"
                      class="ui-button ui-basic-button"
                      @click="submit('')"
                    >
                        픽업 신청하기
                    </button>
                  </li>
                </ul>
              </div>
            </template>
            <template v-else>
              <section class="form-section">
                <h2 class="page-header__title">
                  픽업 신청 완료
                </h2>
              </section>
              <article class="certification">
                <section class="txt aconfirm">
                  <p class="aconfirm-txt">
                    <span class="aconfirm-txt-span">픽업 신청이 완료되었어요</span>
                    <br />
                    곧 기사님이 배송 키트를 픽업해요
                    <br />
                    검수센터에 도착하면,
                    <br />
                    하루 이내에 판매 금액을 알림톡으로 안내드릴게요
                  </p>
                </section>
              </article>
              <div id="regBtnDiv" class="ui-buttons">
                <ul class="ui-buttons__list">
                  <li class="ui-buttons__item">
                    <button
                      type="button"
                      class="ui-button ui-basic-button"
                      @click="handleCloseBtn()"
                    >
                      확인
                    </button>
                  </li>
                </ul>
              </div>
              <div class="cs-center row row_ac row_jsc">
                <span class="qa">고객센터 문의 </span>
                <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
              </div>

            </template>
          </template>
        </template>
      </main>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
import AppConfig from '@/config'
import { DxCheckBox } from "devextreme-vue/check-box";
import Header from '../sale/components/Header.vue'

export default {
  name: 'VisitMintit',
  components: {
    DxCheckBox
    ,Header
  },
  data: () => ({
    ordNum: null,
    isChecked: false,
    isArrived:false,
    isDone:false, // 픽업 신청시
    isCheckedOrder: false, // 1이면 접수완료
    isAlready: false,
  }),
  computed: {
    buttonStyle () {
      return {
        backgroundColor: this.isChecked ? 'black' : 'gray',
        color: 'white',
        cursor: this.isChecked ? 'pointer' : 'not-allowed',
        opacity: this.isChecked ? '1' : '0.5'
      }
    }
  },
  watch:{
    isAlready(newVal){
      // isReady가 true이고, 신청한적 없으면 Alert 노출
      if(newVal){
        if(!this.isCheckedOrder){
          const now = new Date()
          const day = now.getDay()
          const hour = now.getHours()
          const minute = now.getMinutes()
          let val = {}

          if (
            (day === 4 && (hour > 23 || (hour === 23 && minute >= 40))) || // 목요일 23:40 이후
            day >= 5 // 금,토
          ) {
            val = { day: 2, title: '(금,토) ' , add_c: '※ 토요일은 2일 이상 소요' };
          } else {
            val = { day: 1, title: '', add_c: '' };
          }

          let msg = `
              <h3>${val.title}픽업 일정 안내</h3>
              <div style="font-size: 14px; font-weight: 400; line-height:18px;">
                <br> 중고폰 픽업까지 <span class="font-bold line">${val.day}일 정도</span> 소요돼요
                <br> <span class="font-bold">택배사/의 방문 예정 메세지를 확인하고</span>
                <br>중고폰을 문 앞에 놓아주세요
              </div>
              <div style="font-size: 12px; font-weight: 400;">
                ${val.add_c}
              </div>
          `

          // // 2025년 추석
          // const holidayStart = new Date(2025, 9, 3, 0, 0); // 2025-10-03 00:00
          // const holidayEnd   = new Date(2025, 9, 8, 0, 0); // 2025-10-08 00:00
          // 2026년 설
          const holidayStart = new Date(2026, 1, 12, 0, 0); // 2026-10-12 00:00
          const holidayEnd   = new Date(2026, 1, 20, 0, 0); // 2025-10-20 00:00

          if (now >= holidayStart && now < holidayEnd) {
            msg = `
              <h3>설 연휴 픽업 일정 안내</h3>
              <div style="font-size: 14px; font-weight: 400; line-height:18px;">
                <br> 설 연휴 기간 동안 택배 업무가 중단되어
                <br><span class="font-bold line">2/19(목)</span>부터 순차적으로 픽업이 진행돼요
                <br>
                <br> <span class="font-bold">택배사의 방문 예정 메세지를 확인</span>하고
                <br>중고폰을 문 앞에 놓아주세요
              </div>
            `
          }
          
          this.$Alert.customAlert(msg, true, '확인했어요')
        }
      }
    }
  },
  async mounted () {
    this.ordNum  = decodeURIComponent(this.$route.query.ordNum).trim();
    await this.checkOrder()
  },
  methods: {
    async submit () {

      if (!this.ordNum) {
        this.$Alert.alert('접수번호 값이 존재하지 않습니다.');
        return;
      }

      if (!this.isChecked) {
        this.$Alert.alert('약관동의는 필수 입니다')
        return
      } else {
        const {data} = await this.$http.post('/api/purchase/logitics/public/insertLogi/noUpdtAddr',this.ordNum);
        if(data.result == "B"){
          this.isCheckedOrder = true
        }else{
          if(data.result !== "") {
         		this.$Alert.alert(data.result);
          } else {
            this.isDone = true
          }  
        }  
      }
    },
    async checkOrder () {
      const {data} = await this.$http.get(`/api/purchase/logitics/public/checkCount?ordNum=${this.ordNum}`)
      // S 면 신청가능, D면 신청이미 완료, N 이면 아직 배송도착전
      // isArrived - > 배송도착여부 
      // isAlready -> 신청가능
      // isCheckedOrder => 배송 이미 신청 완료된 건

      if(data.result === 'N'){
        this.isArrived = true
      } else if (data.result === 'S'){
        this.isAlready = true
      } else {
        this.isCheckedOrder = true
      }
    },

    closeWindow () {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('kakaotalk') > -1) {
        if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1) {
          window.location.href = 'kakaoweb://closeBrowser'
        } else {
          window.location.href = 'kakaotalk://inappbrowser/close'
        }
      } else if (window) {
        if (window.opener) {
          window.opener.close()
        }
        window.close()
      }
    },


    handleCloseBtn(){
      this.closeWindow()
      return
    }
  }
}
</script>

<style scoped>
.return-txt-span{
  font-weight: bold;
  font-size:18px;
  margin-bottom: 20px;
}

.aconfirm-txt-span{
  font-weight: bold;
  font-size:18px;
  margin-bottom: 20px;
}

.donate-container2{
  font-family:"SUIT", sans-serif;
  max-width:710px;
  width:100%;
  border-radius: 18.205px;
  background: #FFF;
  padding:106px 59px 51px;
}

.cstm-font-red {
  justify-content: center;
  align-items: center;
  display: flex;
  color:#f64c4c;
}


@media (max-width: 600px) {
  .donate-container2{
      padding:54px 29px 26px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/purchase/home/VisitMintit.vue